<template>
    <div class="sa-summery-note">
        <h6>Summary note</h6>
        <textarea placeholder="Add here" v-model="textareaValue" @input="updateValue"></textarea>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            textareaValue: ''
        }
    },
    methods: {
        updateValue() {
            this.$emit('input', this.textareaValue);
        }
    }
}
</script>